import React from 'react';
import { RootContainer } from './styled';
import { RequestTables } from './requestTables';
import {
  InvalidIntervalType,
  useInvalidIntervalMessage,
} from '@src/hooks/useInvalidIntervalMessage';

export const AppAnalyseNetworkRequest: React.FC = () => {
  const invalidIntervalMessage = useInvalidIntervalMessage({
    type: InvalidIntervalType.NETWORK_REQUEST_TAB,
  });

  const renderContent = () => {
    if (invalidIntervalMessage) {
      return invalidIntervalMessage;
    }

    return <RequestTables />;
  };

  return <RootContainer>{renderContent()}</RootContainer>;
};
